import { Auth, Amplify } from 'aws-amplify';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var awsConfig = function awsConfig(settings) {
  return {
    Auth: {
      identityPoolId: '',
      region: settings.region,
      userPoolId: settings.userPoolId,
      userPoolWebClientId: settings.userPoolWebClientId,
      mandatorySignIn: settings.mandatorySignIn
    },
    API: {
      endpoints: [{
        name: settings.endpointName,
        endpoint: settings.endpointUrl,
        custom_header: function () {
          var _custom_header = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = "Bearer ";
                    _context.next = 3;
                    return Auth.currentSession();

                  case 3:
                    _context.t1 = _context.sent.getIdToken().getJwtToken();
                    _context.t2 = _context.t0.concat.call(_context.t0, _context.t1);
                    return _context.abrupt("return", {
                      Authorization: _context.t2
                    });

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function custom_header() {
            return _custom_header.apply(this, arguments);
          }

          return custom_header;
        }()
      }]
    }
  };
};

var awsConfigPublic = function awsConfigPublic(settings) {
  return {
    API: {
      endpoints: [{
        name: settings.endpointName,
        endpoint: settings.endpointUrl
      }]
    }
  };
};

var configureAmplify = function configureAmplify(settings) {
  var isPublic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  Amplify.configure(isPublic ? awsConfigPublic(settings) : awsConfig(settings));
};

export { configureAmplify };
